import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AccessRequestActions } from '../actions/index';
import { ApiService } from '../../../../SGRE-shared/services/api.service';
import { GlobalService } from '../../../../SGRE-shared/services/global.service';
import { AccessRequestEffectsService } from './access-request-effects.service';
import { AccessRequestDetails } from '../access-request.state';
import { LoggerService, tryNormalizeHttpError } from '@spartacus/core';

@Injectable()

export class AccessRequestEffects {

    protected logger = inject(LoggerService);

    constructor(
        private actions$: Actions,
        private readonly apiService: ApiService,
        private globalService: GlobalService,
        private accessRequestEffectsService: AccessRequestEffectsService,
    ) { }

    fetchAccessRequest$: Observable<
        ReturnType<typeof AccessRequestActions.fetchAccessRequestSuccess> |
        ReturnType<typeof AccessRequestActions.fetchAccessRequestFail>
    > = createEffect(() =>
        this.actions$.pipe(
            ofType(AccessRequestActions.fetchAccessRequest),
            switchMap((action) => {
                this.globalService.loadingSubject.next(true);
                return this.apiService.getAccessRequestList(action.payload)
                    .pipe(
                        map((data: AccessRequestDetails) => {
                            this.globalService.loadingSubject.next(false);
                            return AccessRequestActions.fetchAccessRequestSuccess({
                                payload: this.accessRequestEffectsService.createTableConfiguration(data?.legalEntityPendingRoles)
                            });
                        }),
                        catchError((error) => {
                            this.globalService.loadingSubject.next(false);
                            return of(AccessRequestActions.fetchAccessRequestFail({ payload: tryNormalizeHttpError(error, this.logger) }));
                        })
                    );
            })
        )
    );

}